import styled, { css } from 'styled-components';
import { getImageUrl, media } from 'utils';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1rem 2rem;
  min-height: 80px;
  z-index: 20;
  display: flex;
  background: #202025;
  justify-content: center;
  align-items: center;
  height: 4.8rem;

  ${(props) =>
    props.theme.isWidget &&
    css`
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    `};

  @media (min-width: 768px) {
    padding-left: 4.8rem;
    padding-right: 4.8rem;
  }
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const ReportButtonContainer = styled.div`
  width: 12rem;
  padding: 1rem 0;
  border: 1px solid transparent;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  & > svg {
    stroke: white;

    @media (min-width: 768px) {
      width: 2rem;
      height: 2rem;
    }
  }

  & > p {
    margin: 0;
    color: white;
    font-size: 1.4rem;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }

  @media (max-width: 768px) {
    width: 8.5rem;
  }

  &:hover {
    background-color: #222227;
    border: 1px solid #3a3a3f;
  }

  @media (max-width: 768px) {
    &:active {
      background-color: #222227;
      border: 1px solid #3a3a3f;
    }
  }
`;

export const ScreenRecord = styled.div`
  background-size: 24px;
  margin: 0px 5px;
  background-repeat: no-repeat;
  background-position: center center;
  background: #ff0000d9;
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  max-width: 2rem;
  max-height: 2rem;

  box-shadow: 0 0 0 0 #ff0000d9;
  transform: scale(1);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 #ff0000d9;
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
`;

export const RecordingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TimeAndIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const HeaderLogo = styled.div`
  width: 100%;
  min-height: 50%;
  background-image: ${getImageUrl('/icons/mbg-logo.svg')};
  background-repeat: no-repeat;
  display: block;

  &:hover {
    cursor: pointer;
  }

  ${media.mobile`
    height:30px;
  `}
`;

export const MobileLogo = styled.h1`
  font-family: Monoline, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  width: 100%;
  min-height: 50%;
  color: white;

  & > h1 {
    font-size: 2.8rem;
    font-weight: 400;
    margin: 0;
  }
`;

export const RecordingText = styled.p`
  color: white;
  margin: 0;
`;

export const Divider = styled.div`
  height: 2rem;
  width: 0.5px;
  background-color: #ffffff66;
  margin: 0 1rem;
  border-radius: 0.5rem;

  @media (max-width: 768px) {
    margin: 0;
  }
`;
